import store from "@/store";
import { DataStore, syncExpression, Predicates, Hub } from "aws-amplify";
import {
  TeacherProfile,
  Announcement,
  TeacherProductsOrder,
  Product,
  Communication,
  CommunicationTopic,
  ProductCategory,
  ProductTag,
  Taxonomy,
  ProductContent,
  // TeacherAssessmentTemplate,
  AssessmentTemplate,
  // TeacherSubjectTemplate,
  SubjectTemplate,
  School,
  Coupon,
  Secret,
  // TeacherActivity,
  Term,
  Holiday,
  // TeacherClassSubject,
  Subject,
  // TeacherSchedule,
  ReportingTeacher,
  ArchivedTeacherProductsOrder,
  ProductBundle,
  Redirect,
  ProductSEO,
  EcwidCategory,
  EcwidCustomer,
  EcwidOrder,
  EcwidProduct,
  JustBoughtProduct,
  SubscriptionPackage, SubscriptionAccess,
  ReportingOrderProducts
} from "@/models";
import _ from "lodash";
import router from "@/router";

// Create listener
const listener = Hub.listen("datastore", async (hubData) => {
  const { event, data } = hubData.payload;

  // console.log("event, data", event, data);

  if (
    event === "ready" ||
    event === "syncQueriesReady" ||
    (event === "outboxStatus" && data.isEmpty === true)
  ) {
    store.commit("storeDatastoreReady", true);
  } else {
    store.commit("storeDatastoreReady", false);
  }
});

// // Remove listener
// listener();

//one month ago
let now = new Date();
now.setMonth(now.getMonth() - 1);

const oneMonthAgo = now.toISOString();

//6 months ago
now = new Date();
now.setMonth(now.getMonth() - 6);

const sixMonthsAgo = now.toISOString();

// console.log(
//   "JSON.stringify(store.state.datastorePredicates):",
//   JSON.stringify(store.state.datastorePredicates)
// );

export async function reconfigureDatastore() {
  try {
    store.commit("changingDatastoreConfig", true);

    await reconfigureDatastoreDebounced();
  } catch (error) {
    console.error("reconfigureDatastore error", error);
  } finally {
    // store.commit("changingDatastoreConfig", false);
  }
}

const reconfigureDatastoreDebounced = _.debounce(async () => {
  try {
    if (store.state.datastoreSubscriptions.length > 0) {
      store.commit("clearSubscriptions");
      // await store.dispatch("clearSubscriptions");
    }

    // console.log(
    //   "reconfigureDatastoreDebounced JSON.stringify(store.state.datastorePredicates):",
    //   JSON.stringify(store.state.datastorePredicates)
    // );

    // console.log("getRouteParams():", getRouteParams());

    await DataStore.stop();
    // console.log("DataStore stopped");

    // await DataStore.start();
    // console.log("DataStore started");
  } catch (error) {
    console.error("reconfigureDatastoreDebounced error", error);
  } finally {
    store.commit("changingDatastoreConfig", false);
  }
}, 100);

// export async function reconfigureDatastore() {
//   try {
//     store.commit("changingDatastoreConfig", true);

//     if (store.state.datastoreSubscriptions.length > 0) {
//       store.commit("clearSubscriptions");
//     }

//     await DataStore.stop().then(() => {
//       console.log("DataStore stopped");
//     });

//     await DataStore.start();
//     console.log("DataStore started");
//   } catch (error) {
//     console.error("reconfigureDatastore error", error);
//   } finally {
//     store.commit("changingDatastoreConfig", false);
//   }
// }

function datastorePredicates() {
  return store.state.datastorePredicates;
}

function getPredicate(model) {
  return datastorePredicates().find((item) => item.model === model);
}

function getRouteParams() {
  return router?.currentRoute?.params;
}

// function productPredicate() {
//   return store.state.datastorePredicates.find(
//     (item) => item.model === "Product"
//   );
// }

// function productPVariables() {
//   return productPredicate()?.predicateVariables;
// }

DataStore.configure({
  maxRecordsToSync: 100000,
  syncPageSize: 500,
  syncExpressions: [
    syncExpression(Announcement, () => {
      return (model) =>
        getPredicate("Announcement")
          ? getPredicate("Announcement").predicate === "Admin"
            ? Predicates.ALL
            : getPredicate("Announcement").predicate === "Teacher"
            ? model.and((model) => [
                model.or((model) => [
                  model.sendTo("contains", store.state.teacherProfileID),
                  model.sendTo("contains", "ALL"),
                ]),
                model.readBy("notContains", store.state.teacherProfileID),
              ])
            : Predicates.ALL
          : model.id("eq", "");
    }),

    syncExpression(TeacherProductsOrder, () => {
      return (model) =>
        getPredicate("TeacherProductsOrder")
          ? getPredicate("TeacherProductsOrder").predicate === "SuperAdmin"
            ? Predicates.ALL
            : getPredicate("TeacherProductsOrder").predicate === "Admin"
            ? model.or((model) => [
                model.and((model) => [
                  model.orderStatus("eq", "PROCESSING"),
                  model.createdAt("gt", sixMonthsAgo),
                ]),
                model.updatedAt("gt", oneMonthAgo),
              ])
            : model.id("eq", "")
          : // Predicates.ALL
            model.id("eq", "");
    }),

    syncExpression(ReportingTeacher, () => {
      return (model) =>
        getPredicate("ReportingTeacher")
          ? getPredicate("ReportingTeacher").predicate === "Admin"
            ? model.or((model) => [
                model.roles("contains", "admin"),
                model.roles("contains", "teacher"),
              ])
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(Taxonomy, () => {
      return (model) =>
        getPredicate("Taxonomy")
          ? getPredicate("Taxonomy").predicate === "Admin" ||
            getPredicate("Taxonomy").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(AssessmentTemplate, () => {
      return (model) =>
        getPredicate("AssessmentTemplate")
          ? getPredicate("AssessmentTemplate").predicate === "Admin" ||
            getPredicate("AssessmentTemplate").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(School, () => {
      return (model) =>
        getPredicate("School")
          ? getPredicate("School").predicate === "Admin" ||
            getPredicate("School").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(Subject, () => {
      return (model) =>
        getPredicate("Subject")
          ? getPredicate("Subject").predicate === "Admin" ||
            getPredicate("Subject").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(SubjectTemplate, () => {
      return (model) =>
        getPredicate("SubjectTemplate")
          ? getPredicate("SubjectTemplate").predicate === "Admin" ||
            getPredicate("SubjectTemplate").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(Term, () => {
      return (model) =>
        getPredicate("Term")
          ? getPredicate("Term").predicate === "Admin" ||
            getPredicate("Term").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(Holiday, () => {
      return (model) =>
        getPredicate("Holiday")
          ? getPredicate("Holiday").predicate === "Admin" ||
            getPredicate("Holiday").predicate === "Teacher"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(TeacherProfile, () => {
      return (model) =>
        getPredicate("TeacherProfile")
          ? getPredicate("TeacherProfile").predicate === "Admin"
            ? Predicates.ALL
            : getPredicate("TeacherProfile").predicate === "Teacher"
            ? model.id("eq", store.state.teacherProfileID)
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(ProductCategory, () => {
      return (model) =>
        getPredicate("ProductCategory")
          ? getPredicate("ProductCategory").predicate === "Admin" ||
            getPredicate("ProductCategory").predicate === "Teacher" ||
            getPredicate("ProductCategory").predicate === "Public"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(ProductTag, () => {
      return (model) =>
        getPredicate("ProductTag")
          ? getPredicate("ProductTag").predicate === "Admin" ||
            getPredicate("ProductTag").predicate === "Teacher" ||
            getPredicate("ProductTag").predicate === "Public"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(ProductContent, () => {
      return (model) =>
        getPredicate("ProductContent")
          ? getPredicate("ProductContent").predicate === "Admin" ||
            getPredicate("ProductContent").predicate === "Teacher" ||
            getPredicate("ProductContent").predicate === "Public"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(ProductSEO, () => {
      return (model) =>
        getPredicate("ProductSEO")
          ? getPredicate("ProductSEO").predicate === "Admin" ||
            getPredicate("ProductSEO").predicate === "Teacher" ||
            getPredicate("ProductSEO").predicate === "Public"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    syncExpression(Redirect, () => {
      return (model) =>
        getPredicate("Redirect")
          ? getPredicate("Redirect").predicate === "Admin" ||
            getPredicate("Redirect").predicate === "Public"
            ? Predicates.ALL
            : model.id("eq", "")
          : model.id("eq", "");
    }),

    // ========================================
    // ProductBundle Sync Expression
    // ========================================
    syncExpression(ProductBundle, () => {
      return (model) =>
        getPredicate("ProductBundle")
          ? getPredicate("ProductBundle").predicate === "Admin"
            ? Predicates.ALL
            : getPredicate("ProductBundle").predicate === "Teacher" ||
              getPredicate("ProductBundle").predicate === "Public"
            ? model.and((model) => [
                model.publishDate("ne", null),
                model.publishDate("lt", new Date().toISOString()),
                // model.softDeleted("ne", true), // ← Exclude soft-deleted from Teacher/Public
              ])
            : getPredicate("ProductBundle").predicate === "RouteSpecific"
            ? model.and((model) => [
                model.id("eq", getRouteParams()?.productId),
                // model.softDeleted("ne", true), // ← Exclude soft-deleted from RouteSpecific
              ])
            : Predicates.ALL
          : model.id("eq", "");
    }),

    // ========================================
    // Product Sync Expression
    // ========================================
    syncExpression(Product, () => {
      return (model) =>
        getPredicate("Product")
          ? getPredicate("Product").predicate === "Admin"
            ? model.type("eq", "Product") // ← Admin sees ALL products including soft-deleted
            : getPredicate("Product").predicate === "Teacher" ||
              getPredicate("Product").predicate === "Public"
            ? model.and((model) => [
                model.type("eq", "Product"),
                // model.softDeleted("ne", true), // ← Exclude soft-deleted from Teacher/Public
                model.publishDate("ne", null), // Ensure publishDate exists
                model.publishDate("lt", new Date().toISOString()),
                model.or((model) => [
                  model.eCommerceProduct("eq", true),
                  model.subscriptionProduct("eq", true),
                ]),
              ])
            : getPredicate("Product").predicate === "RouteSpecific"
            ? model.and((model) => [
                model.id("eq", getRouteParams()?.productId),
                // model.softDeleted("ne", true), // ← Exclude soft-deleted from RouteSpecific
              ])
            : model.type("eq", "Product")
          : model.id("eq", "");
    }),

    syncExpression(ArchivedTeacherProductsOrder, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(EcwidCategory, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(EcwidCustomer, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(EcwidOrder, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(EcwidProduct, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(JustBoughtProduct, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(ReportingOrderProducts, () => {
      return (model) => model.id("eq", "");
    }),

    syncExpression(SubscriptionPackage, () => {
      return (model) => model.id("eq", "");
    }),
    
    syncExpression(SubscriptionAccess, () => {
      return (model) => model.id("eq", "");
    }),
  ],
});

// syncExpression(Product, () => {
//   return (model) =>
//     productPredicate()
//       ? productPredicate().predicate === "Public"
//         ? (model) =>
//             model.and((f) => [
//               f.or((f) => [
//                 f.and((f) => [
//                   f.eCommerceProduct("eq", true),
//                   //HIDE-subscription-17Dec2024

//                   // this.syncedSubscribedCategoryIDArray.map((id) =>
//                   //   f.categoryId("ne", id)
//                   // ),
//                 ]),
//                 f.and((f) => [
//                   f.subscriptionProduct("eq", true),
//                   productPVariables().viewMySubscribedProducts
//                     ? store.state.syncedTeacherProfileModel
//                         ?.productSubscriptions?.length > 0
//                       ? f.or((f) =>
//                           store.state.syncedTeacherProfileModel.productSubscriptions.map(
//                             (pS) => f.id("eq", pS.productId)
//                           )
//                         )
//                       : f.id("eq", null)
//                     : f.subscriptionProduct("ne", true),
//                 ]),
//               ]),
//               f.thumbnails("gt", []),
//               f.publishDate("lt", productPVariables().currentDateTime),
//               productPVariables()
//                 .search.map((str) => str.toLowerCase())
//                 .every((string) => f.searchField("contains", string)),

//               f.or((f) => [
//                 productPVariables().viewMySubscribedProducts
//                   ? store.state.syncedTeacherProfileModel
//                       ?.productSubscriptions?.length > 0
//                     ? f.or((f) =>
//                         store.state.syncedTeacherProfileModel.productSubscriptions.reduce(
//                           (c, pS) => c.id("eq", pS.productId),
//                           f
//                         )
//                       )
//                     : f.id("eq", null)
//                   : true,

//                 productPVariables().viewMyBoughtProducts
//                   ? store.state.syncedBoughtProducts?.length > 0
//                     ? f.or((f) =>
//                         store.state.syncedBoughtProducts.reduce(
//                           (c, pS) => c.id("eq", pS),
//                           f
//                         )
//                       )
//                     : f.id("eq", null)
//                   : true,
//               ]),
//               productPVariables().showFeatured
//                 ? f.featured("eq", true)
//                 : true,
//               productPVariables().productsSearchTags.some((tag) =>
//                 f.tags("contains", tag)
//               ),
//               productPVariables().routeCategory
//                 ? f.or((f) =>
//                     productPVariables().routeCategoryArray.reduce(
//                       (c, id) => c.categoryId("eq", id),
//                       f
//                     )
//                   )
//                 : true,
//               f.or((f) =>
//                 productPVariables().productsSearchCategories.reduce(
//                   (c, id) => c.categoryId("eq", id),
//                   f
//                 )
//               ),
//             ])
//         : productPredicate().predicate === "Teacher"
//         ? (model) =>
//             model.and((f) => [
//               f.or((f) => [
//                 f.and((f) => [
//                   f.eCommerceProduct("eq", true),
//                   //HIDE-subscription-17Dec2024

//                   // this.syncedSubscribedCategoryIDArray.map((id) =>
//                   //   f.categoryId("ne", id)
//                   // ),
//                 ]),
//                 f.and((f) => [
//                   f.subscriptionProduct("eq", true),
//                   productPVariables().viewMySubscribedProducts
//                     ? store.state.syncedTeacherProfileModel
//                         ?.productSubscriptions?.length > 0
//                       ? f.or((f) =>
//                           store.state.syncedTeacherProfileModel.productSubscriptions.map(
//                             (pS) => f.id("eq", pS.productId)
//                           )
//                         )
//                       : f.id("eq", null)
//                     : f.subscriptionProduct("ne", true),
//                 ]),
//               ]),
//               f.thumbnails("gt", []),
//               f.publishDate("lt", productPVariables().currentDateTime),
//               productPVariables()
//                 .search.map((str) => str.toLowerCase())
//                 .every((string) => f.searchField("contains", string)),

//               f.or((f) => [
//                 productPVariables().viewMySubscribedProducts
//                   ? store.state.syncedTeacherProfileModel
//                       ?.productSubscriptions?.length > 0
//                     ? f.or((f) =>
//                         store.state.syncedTeacherProfileModel.productSubscriptions.reduce(
//                           (c, pS) => c.id("eq", pS.productId),
//                           f
//                         )
//                       )
//                     : f.id("eq", null)
//                   : true,

//                 productPVariables().viewMyBoughtProducts
//                   ? store.state.syncedBoughtProducts?.length > 0
//                     ? f.or((f) =>
//                         store.state.syncedBoughtProducts.reduce(
//                           (c, pS) => c.id("eq", pS),
//                           f
//                         )
//                       )
//                     : f.id("eq", null)
//                   : true,
//               ]),
//               productPVariables().showFeatured
//                 ? f.featured("eq", true)
//                 : true,
//               productPVariables().productsSearchTags.some((tag) =>
//                 f.tags("contains", tag)
//               ),
//               productPVariables().routeCategory
//                 ? f.or((f) =>
//                     productPVariables().routeCategoryArray.reduce(
//                       (c, id) => c.categoryId("eq", id),
//                       f
//                     )
//                   )
//                 : true,
//               f.or((f) =>
//                 productPVariables().productsSearchCategories.reduce(
//                   (c, id) => c.categoryId("eq", id),
//                   f
//                 )
//               ),
//             ])
//         : productPredicate().predicate === "Admin"
//         ? (model) =>
//             model.and((f) => [
//               productPVariables().productsDataTableSearchTags.every((tag) =>
//                 f.tags("contains", tag)
//               ),
//               f.or((f) =>
//                 productPVariables().productsDataTableSearchCategories.reduce(
//                   (c, id) => c.categoryId("eq", id),
//                   f
//                 )
//               ),
//               productPVariables()
//                 .search.map((str) => str.toLowerCase())
//                 .every((string) => f.searchField("contains", string)),

//               productPVariables().searchECommerceProduct
//                 ? f.eCommerceProduct("eq", true)
//                 : f,
//               productPVariables().searchPhysicalProduct
//                 ? f.physical("eq", true)
//                 : f,
//               productPVariables().searchSubscriptionProduct
//                 ? f.subscriptionProduct("eq", true)
//                 : f,
//             ])
//         : Predicates.ALL
//       : model.id("eq", "");
// }),
